<div class="row mb-130 main-row align-items-center ">
    <div class="col-md-5 offset-md-1" style="z-index: 1;">
        <div class="timeline-container">
            <div class="row">
                <div class="">
                    <div class="steps">
                        <h5 class="titleSteps text-white font-weight-bold">Pasos para ingresar a la herramienta</h5>
                        <!-- <p class="pSteps">Consulte los pasos a seguir y agende su cita con éxito.</p> -->
                        <br><br>

                        <div class="row align-items-center  d-flex">
                            <div
                                class="col-2 text-center bottom d-inline-flex justify-content-center align-items-center">
                                <div class="circle font-weight-bold text-white">1</div>
                            </div>
                            <div class="col-9">
                                <!-- <h6>DATOS GENERALES</h6> -->
                                <p class="step-text text-white">Ingrese su número de identificación para validar sus
                                    datos personales y de contacto.</p>
                            </div>
                        </div>

                        <div class="row timeline">
                            <div class="col-2">
                                <div class="corner top-right"></div>
                            </div>
                            <div class="col-8">
                                <hr />
                            </div>
                            <div class="col-2">
                                <div class="corner left-bottom"></div>
                            </div>
                        </div>

                        <div class="row align-items-center justify-content-end  d-flex">
                            <div class="col-9 text-end">
                                <!-- <h6>Fecha y hora</h6> -->
                                <p class="step-text text-white">Seleccione una forma de contacto para recibir un enlace
                                    temporal de acceso.</p>
                            </div>
                            <div class="col-2 text-center full d-inline-flex justify-content-center align-items-center">
                                <div class="circle font-weight-bold">2</div>
                            </div>
                        </div>

                        <div class="row timeline">
                            <div class="col-2">
                                <div class="corner right-bottom"></div>
                            </div>
                            <div class="col-8">
                                <hr />
                            </div>
                            <div class="col-2">
                                <div class="corner top-left"></div>
                            </div>
                        </div>

                        <div class="row align-items-center  d-flex">
                            <div class="col-2 text-center top d-inline-flex justify-content-center align-items-center">
                                <div class="circle font-weight-bold">3</div>
                            </div>
                            <div class="col-9">
                                <!-- <h6>Información personal</h6> -->
                                <p class="step-text text-white">Revise su correo electrónico y siga las instrucciones
                                    descritas para completar su solicitud.</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="col-md-5">
        <div class="form-container">
            <h5 class="mb-0 mt-1 text-center text-primary mb-4 font-weight-bold">
                Presolicitudes de crédito
            </h5>
            <!-- </div> -->
            <div>
                <form #form="ngForm" action="#" (ngSubmit)="checkStep()">
                    <div *ngIf="customerName" class="row px-3">
                        <div class="col-2 pr-1">
                            <i class="fa fa-user icon-user"></i>
                        </div>
                        <div class="col-10 pt-1">
                            <p class="text-muted mb-0">{{finaluserIdentifier}}</p>
                            <h6 class="text-primary">Bienvenido {{customerName}}</h6>
                        </div>
                    </div>
                    <p class="text-muted my-1">{{getInfoMessage()}}</p>

                    <!-- <hr class="my-5"> -->

                    <div class="">
                        <!-- INIT ID QUERY -->
                        <div class="my-4" *ngIf="step == 'CHECK'">
                            <label for="inputId" class="form-label text-start">Identificación*</label>
                            <div class="input-group mb-3">
                                <input type="text" name="user_id" class="form-control" id="inputId"
                                [(ngModel)]="userIdentifier" maxlength="20" required>                               
                                <div class="input-group-prepend">
                                    <span class="input-group-text icon-inpu" id="basic-addon1"><i
                                            class="fa fa-id-card"></i></span>
                                </div>

                            </div>
                        </div>
                        <!-- INIT ID QUERY -->
                        <!-- CUSTOMER WITH VERIFIED DATA -->
                        <div *ngIf="step == 'V_INFO' || step == 'H_INFO' ">
                            <ul class="nav nav-tabs">
                                <li class="nav-item" [class.active]="activeTab === 'mails'" >
                                    <a class="nav-link" [class.active]="activeTab === 'mails'"  [class.disabled]="userEmails.length == 0"
                                        data-toggle="tab" href="public/presolicitud#mails">
                                        <span class="d-none d-md-block">
                                            Correos
                                        </span>
                                        <i class="fa fa-envelope d-block d-sm-block d-md-none"></i>
                                    </a>
                                </li>
                                <li class="nav-item" [class.active]="activeTab === 'phones'" >
                                    <a class="nav-link" [class.active]="activeTab === 'phones'"  [class.disabled]="userPhones.length == 0"
                                     data-toggle="tab" href="public/presolicitud#phones">
                                        <span class="d-none d-md-block">
                                            Telefonos
                                        </span>
                                        <i class="fa fa-phone d-block d-sm-block d-md-none"> </i>
                                    </a>
                                </li>
                            </ul>

                            <!-- Tab panes -->
                            <div class="tab-content mb-4 pt-2">
                                <div class="tab-pane" [class.active]="activeTab === 'mails'" id="mails" [disabled]="userEmails.length == 0">

                                    <!-- V_INFO -->
                                    <div *ngIf="step == 'V_INFO' && userEmails.length > 0">
                                        <p class="text-muted">{{'Por favor complete el siguiente correo en campo
                                            que se muestra ' + toCompleteMail}}</p>
                                        <div class="form-group">
                                            <label for="inputMail" class="form-label">Ingrese el email
                                                censurado:</label>
                                            <input type="mail" name="inputMail" class="form-control" id="inputMail"
                                                [(ngModel)]="inputMail" required>
                                        </div>
                                    </div>

                                    <!-- H_INFO -->
                                    <div *ngIf="step == 'H_INFO' && userEmails.length > 0">
                                        <p class="text-muted">{{'Por favor complete el siguiente correo en campo
                                            que se muestra ' + toCompleteMail}}</p>
                                        <div class="form-group">
                                            <label for="inputMail" class="form-label">Seleccione el email que sea
                                                utilizar:</label>
                                            <select [(ngModel)]="toCompleteMail" class="form-control" name="selectEmail"
                                                id="selectEmail" required>
                                                <option *ngFor="let email of userEmails;let i = index" [value]="email">
                                                    {{email}}</option>
                                            </select>
                                        </div>

                                        <div class="form-group">
                                            <label for="inputMail" class="form-label">Ingrese el email
                                                censurado:</label>
                                            <input type="mail" name="inputMail" class="form-control" id="inputMail"
                                                [(ngModel)]="inputMail" required>
                                        </div>
                                    </div>

                                </div>
                                <!-- TAB Phones -->
                                <div class="tab-pane" [class.active]="activeTab === 'phones'" id="phones">
                                    <!-- V_INFO -->
                                    <div *ngIf="step == 'V_INFO' && userPhones.length > 0">
                                        <p class="text-muted">{{'Por favor ingrese los ultimos 4 dígitos del celular
                                            seleccionado en campo
                                            que se muestra ' + toCompletePhone}}</p>
                                        <div class="form-group">
                                            <label for="inputPhone" class="form-label">Ingrese los ultimos 4 dígitos del
                                                celular seleccionado:</label>
                                            <input type="mail" name="inputPhone" class="form-control" id="inputPhone"
                                                [(ngModel)]="inputPhone" required>
                                        </div>
                                    </div>

                                    <!-- H_INFO -->
                                    <div *ngIf="step == 'H_INFO' && userPhones.length > 0">
                                        <p class="text-muted">{{'Por favor ingrese los ultimos 4 dígitos del celular
                                            seleccionado en campo
                                            que se muestra ' + toCompletePhone}}</p>
                                        <div class="form-group">
                                            <label for="selectPhone" class="form-label">Seleccione el teléfono que sea
                                                utilizar:</label>
                                            <select [(ngModel)]="toCompletePhone" class="form-control"
                                                name="selectPhone" id="selectPhone" required>
                                                <option *ngFor="let phone of userPhones;let i = index" [value]="phone">
                                                    {{phone}}</option>
                                            </select>
                                        </div>

                                        <div class="form-group">
                                            <label for="inputPhone" class="form-label">Ingrese los ultimos 4 dígitos del
                                                celular seleccionado:</label>
                                            <input type="number" name="inputPhone" class="form-control" id="inputPhone"
                                                [(ngModel)]="inputPhone" required>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- CUSTOMER WITH NO DATA -->
                        <div class="my-4" *ngIf="step == 'N_INFO'">

                            <label for="contactType" class="form-label text-start">Tipo de medio:*</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon10"><i
                                            class="fa fa-address-book"></i></span>
                                </div>
                                <select type="text" name="contactType" class="form-control" id="contactType"
                                    [(ngModel)]="contactType" maxlength="50" required>
                                    <option value="">Seleccione una opción</option>
                                    <option value="C">Celular</option>
                                    <option value="E">Correo electrónico</option>
                                </select>
                            </div>

                            <label  for="newContact" class="form-label text-start">Medio de
                                contacto:*</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon10"><i
                                            class="fa fa-address-book"></i></span>
                                </div>

                                <input type="text" name="newContactInput" class="form-control"
                                    id="newContactInput" #newContactNg="ngModel" [pattern]="contactType === 'E' ? mailPattern : phonePattern" [(ngModel)]="newContactInput" maxlength="50" required>
                            </div>

                            <small class="help-block text-danger"
                            *ngIf="newContactNg.errors?.pattern && newContactNg.touched">{{contactType === 'E' ? 'Por
                            favor ingrese un email válido.' : 'Por favor ingrese un telefono válido.'}}</small>
                            
                        </div>

                        <button style="width: 100%;" [disabled]="(step == 'N_INFO' && form.invalid)" type="submit" class="btn th-bg-main th-text-white btn-block">{{getBtnText()}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>